import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button" }

import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContentCardSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!

  return (_openBlock(), _createBlock(_unref(IonCard), { "data-test": "card-content-skeleton" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSkeletonText), {
                "data-test": "title",
                style: {"width":"80%","height":"22px"},
                animated: true
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSkeletonText), {
            "data-test": "icon",
            animated: true,
            class: "icon-wrapper"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSkeletonText), {
            "data-test": "description",
            animated: true,
            style: {"width":"100%","height":"14px"}
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonSkeletonText), {
          "data-test": "button",
          animated: true,
          style: {"width":"30%","height":"30px"}
        })
      ])
    ]),
    _: 1
  }))
}
}

})